<template>
  <div class="SeparacaoEDivorcio">
    <div class="row mt-2">
      <div class="col-12">
        <div v-if="form.origem === 'ESCRITURA'"
             class="row mb-2">
          <div class="col-2">
            <label for="data_escritura"
                   class="label">Data da Escritura</label>
            <input id="data_escritura"
                   v-model="form.data_escritura"
                   v-validate="'required'"
                   type="date"
                   name="data_escritura"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('data_escritura')}"
                   @change="changed">
            <small class="invalid-feedback">{{ !form.data_escritura ? 'Data obrigatória' : errors.first('data_escritura') }}</small>
          </div>
          <div class="col-2">
            <label for="num_livro"
                   class="label">Num. Livro</label>
            <input id="num_livro"
                   v-model="form.num_livro"
                   v-validate="'required'"
                   type="number"
                   min="1"
                   name="num_livro"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('num_livro')}"
                   @change="changed">
            <small class="invalid-feedback">{{ !form.num_livro ? 'Campo obrigatório' : errors.first('num_livro') }}</small>
          </div>
          <div class="col-2">
            <label for="num_folha"
                   class="label">Num. Folha</label>
            <input id="num_folha"
                   v-model="form.num_folha"
                   v-validate="'required'"
                   type="number"
                   min="1"
                   name="num_folha"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('num_folha')}"
                   @change="changed">
            <small class="invalid-feedback">{{ !form.num_folha ? 'Campo obrigatório' : errors.first('num_folha') }}</small>
          </div>
        </div>
        <div v-if="form.origem === 'ESCRITURA'"
             class="row mb-2">
          <div class="col-2">
            <label class="label"
                   for="uf">UF</label>
            <v-select id="uf"
                      v-model="form.uf"
                      class="form-control form-control-sm"
                      name="uf"
                      placeholder="Selecione"
                      :options="estados.map((state)=>state.uf)"
                      @input="ufChanged" />
            <small class="invalid-feedback">{{ errors.first('uf') }}</small>
          </div>
          <div class="col-4">
            <label class="label"
                   for="cidade">Cidade</label>
            <v-select id="cidade"
                      v-model="form.cidade"
                      name="cidade"
                      class="form-control form-control-sm"
                      placeholder="Selecione"
                      :searchable="form.uf !== 'EX'"
                      :options="citiesFiltered.map((city)=>city.nome)"
                      @input="changed" />
          </div>
          <div class="col">
            <label class="label"
                   for="cartorio">Cartório</label>
            <input id="cartorio"
                   v-model="form.cartorio"
                   v-validate="'required'"
                   type="text"
                   name="cartorio"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('cartorio')}"
                   @change="changed">
            <small class="invalid-feedback">{{ errors.first('cartorio') }}</small>
          </div>
        </div>
        <div v-if="form.origem === 'MANDADO'"
             class="row mb-2">
          <div class="col-8 p-0 m-0 d-inline-flex">
            <div class="col-4">
              <label for="data_sentenca"
                     class="label">Data da Sentença</label>
              <input id="data_sentenca"
                     v-model="form.data_sentenca"
                     v-validate="'required'"
                     type="date"
                     name="data_sentenca"
                     class="form-control form-control-sm"
                     :class="{'is-invalid': errors.has('data_sentenca')}"
                     @change="changed">
              <small class="invalid-feedback">{{ !form.data_sentenca ? 'Data obrigatória' : errors.first('data_sentenca') }}</small>
            </div>
            <div class="col-4">
              <label for="data_transito_julgado"
                     class="label">Data do trânsito em julgado</label>
              <input id="data_transito_julgado"
                     v-model="form.data_transito_julgado"
                     v-validate="'required'"
                     type="date"
                     name="data_transito_julgado"
                     class="form-control form-control-sm"
                     :class="{'is-invalid': errors.has('data_transito_julgado')}"
                     @change="changed">
              <small class="invalid-feedback">{{ !form.data_transito_julgado ? 'Data obrigatória' : errors.first('data_transito_julgado') }}</small>
            </div>
            <div class="col-4">
              <label for="data_mandado"
                     class="label">Data do mandado</label>
              <input id="data_mandado"
                     v-model="form.data_mandado"
                     v-validate="'required'"
                     type="date"
                     name="data_mandado"
                     class="form-control form-control-sm"
                     :class="{'is-invalid': errors.has('data_mandado')}"
                     @change="changed">
              <small class="invalid-feedback">{{ !form.data_mandado ? 'Data obrigatória' : errors.first('data_mandado') }}</small>
            </div>
          </div>
          <div class="col-4">
            <label class="label"
                   for="num_processo">Número do processo</label>
            <input id="num_processo"
                   v-model="form.num_processo"
                   v-validate="'required'"
                   type="text"
                   name="num_processo"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('num_processo')}"
                   @change="changed">
            <small class="invalid-feedback">{{ errors.first('num_processo') }}</small>
          </div>
        </div>
        <div v-if="form.origem === 'MANDADO'"
             class="row mb-2">
          <div class="col-2">
            <label class="label"
                   for="uf">UF</label>
            <v-select id="uf"
                      v-model="form.uf"
                      v-validate="'required'"
                      class="form-control form-control-sm"
                      name="uf"
                      placeholder="Selecione"
                      :options="estados.map((state)=>state.uf)"
                      :class="{'is-invalid': errors.has('uf')}"
                      @input="ufChanged" />
            <small class="invalid-feedback">{{ errors.first('uf') }}</small>
          </div>
          <div class="col-4">
            <label class="label"
                   for="comarca">Comarca</label>
            <input id="comarca"
                   v-model="form.comarca"
                   v-validate="'required'"
                   type="text"
                   name="comarca"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('comarca')}"
                   @change="changed">
            <small class="invalid-feedback">{{ errors.first('comarca') }}</small>
          </div>
          <div class="col-3">
            <label class="label"
                   for="vara">Vara</label>
            <input id="vara"
                   v-model="form.vara"
                   v-validate="'required'"
                   type="text"
                   name="vara"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('vara')}"
                   @change="changed">
            <small class="invalid-feedback">{{ errors.first('vara') }}</small>
          </div>
          <div class="col-3">
            <label class="label"
                   for="juiz">Juiz</label>
            <input id="juiz"
                   v-model="form.juiz"
                   v-validate="'required'"
                   type="text"
                   name="juiz"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('juiz')}"
                   @change="changed">
            <small class="invalid-feedback">{{ errors.first('juiz') }}</small>
          </div>
        </div>
        <div v-if="form.acao === 'ALTERACAO_ESTADO_CIVIL'"
             class="row mb-2">
          <div class="col-6">
            <label for="nome_conjuge_1"
                   class="label">Nome após a alteração - Cônjuge 1</label>
            <input id="nome_conjuge_1"
                   v-model="form.nome_conjuge_1"
                   type="text"
                   name="nome_conjuge_1"
                   class="form-control form-control-sm"
                   @change="changed">
          </div>
          <div class="col-6">
            <label for="nome_conjuge_2"
                   class="label">Nome após a alteração - Cônjuge 2</label>
            <input id="nome_conjuge_2"
                   v-model="form.nome_conjuge_2"
                   type="text"
                   name="nome_conjuge_2"
                   class="form-control form-control-sm"
                   @change="changed">
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-3">
            <label for="cpf_requerente"
                   class="label">CPF Requerente</label>
            <input id="cpf_requerente"
                   v-model="form.cpf_requerente"
                   v-mask="{ mask:'999.999.999-99' }"
                   v-validate="{ required: true, regex: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/, min: 14, max: 14 }"
                   :class="{ 'is-invalid': errors.has('cpf_requerente')}"
                   type="text"
                   name="cpf_requerente"
                   class="form-control form-control-sm"
                   @change="searchCPF()">
            <small class="invalid-feedback">{{ errors.first('cpf_requerente') }}</small>
          </div>
          <div class="col-6">
            <label for="nome_requerente"
                   class="label">Nome Requerente</label>
            <input id="nome_requerente"
                   v-model="form.nome_requerente"
                   v-validate="{ required: true }"
                   :class="{ 'is-invalid': errors.has('nome_requerente')}"
                   type="text"
                   name="nome_requerente"
                   class="form-control form-control-sm"
                   @change="changed">
            <small class="invalid-feedback">{{ errors.first('nome_requerente') }}</small>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2">
            <label for="data_averbacao"
                   class="label">Data da solicitação</label>
            <input id="data_averbacao"
                   v-model="form.data_averbacao"
                   v-validate="'required'"
                   :class="{ 'is-invalid': errors.has('data_averbacao')}"
                   type="date"
                   name="data_averbacao"
                   class="form-control form-control-sm"
                   @change="changed">
            <small class="invalid-feedback">{{ !form.data_averbacao ? 'Data obrigatória' : errors.first('data_averbacao') }}</small>
          </div>
          <div class="col-7 d-inline-flex align-items-center justify-content-between pt-2">
            <b-form-checkbox v-model="form.isento"
                             :value="true"
                             @change="changed">
              Isento de emolumentos
            </b-form-checkbox>
            <b-form-checkbox v-if="!form.protocolo_id"
                             v-model="form.gerar_protocolo"
                             :value="true"
                             @change="changed">
              Gerar protocolo automaticamente
            </b-form-checkbox>
            <b-form-checkbox v-if="!form.procedimento_id"
                             v-model="form.gerar_os"
                             :value="true"
                             @change="changed">
              Gerar O.S
            </b-form-checkbox>
          </div>
        </div>
        <div class="pl-3">
          <div v-if="form.procedimentoArquivo.length">
            <div class="row mb-2">
              <div v-for="(documento, index) in form.procedimentoArquivo"
                   :key="index">
                <Documento :prop-documento="documento.pdf ? documento.pdf : documento"
                           :prop-index="index"
                           @deleteDocumento="deleteDocumento" />
              </div>
            </div>
          </div>
          <div v-if="showFile ">
            <div class="row mb-2 mt-3">
              <div class="col-8 pl-0">
                <div class="DropArea AdicionarImagem--border d-flex justify-content-center align-items-center">
                  <div>
                    <span>
                      Arraste o arquivo PDF aqui ou <label for="preparar-processo-imagem"><u>procure manualmente</u></label> para upload
                    </span>
                  </div>
                </div>

                <input v-show="showFile"
                       id="preparar-processo-imagem"
                       v-validate="{mimes: ['application/pdf']}"
                       type="file"
                       name="livroCaixaLancamentoArquivo"
                       :class="['form-control-sm form-control-file fileObrigatorio']"
                       accept="application/pdf"
                       multiple
                       @dragover="($event) => dragArea($event)"
                       @dragleave="($event) => dragAreaOut($event)"
                       @drop="drop()"
                       @change="addArquivo">

                <div v-if="errors.has(`documento`)"
                     class="text-center">
                  <small class="text-danger">Certifique-se de estar escolhendo um documento <strong>PDF</strong></small>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2 mt-3">
            <div class="col-12 p-0">
              <button class="btn btn-sm btn-primary px-5"
                      :disabled="showFile"
                      @click="showFile = true">
                <icon-svg icon="add"
                          class="icon-add-images icon--sm mr-1" />
                Adicionar mais imagens
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="texto-livre"
                   class="label">Texto da certidão</label>
            <textarea id="texto-livre"
                      v-model="form.texto_procedimento"
                      v-validate="'required'"
                      name="texto-livre"
                      cols="30"
                      rows="10"
                      class="form-control form-control-sm"
                      :class="{'is-invalid': errors.has('texto-livre')}" />
            <small class="invalid-feedback">{{ errors.first('texto-livre') }}</small>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-light btn-sm mr-2"
                @click="$emit('hideForm')">
          Voltar
        </button>
        <button v-if="!propForm.procedimento_id"
                class="btn btn-primary btn-sm"
                @click="salvarProcedimento()">
          Cumprir
        </button>
        <button v-else
                class="btn btn-primary btn-sm"
                @click="editarProcedimento()">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  // constants
  import { ESTADOS_CIVIL_HABILITACAO } from "@/constants/estadosCivil"

  // components
  import Documento from '@/components/LivroCaixa/DocumentoLivroCaixa.vue'

  //services
  import EnderecosService from "@/services/Enderecos"
  import PessoasService from "@/services/Pessoas"

  // outros
  import moment from 'moment'

  // filters
  import { filterMaskedNumber, maskCPF } from '@/filters/filters'

  export default {
    name: 'SeparacaoEDivorcio',
    components: {
      Documento
    },
    props: {
      propForm: { type: Object, default: null }
    },
    data () {
      return {
        estadosCivis: ESTADOS_CIVIL_HABILITACAO,
        tipos: [
          'Divórcio',
          'Separação',
          'Reconciliação',
          'Desquite',
          'Anulação'
        ],
        formas: [
          'Escritura',
          'Mandado Judicial'
        ],
        coisas: ['Alteração do estado civil'],
        form: {
          procedimentoArquivo: [],
          acao: null,
          motivo: null,
          origem: null,
          data_escritura: null,
          data_sentenca: null,
          data_transito_julgado: null,
          data_mandado: null,
          num_processo: null,
          num_livro: null,
          num_folha: null,
          uf: null,
          cidade: null,
          cartorio: null,
          comarca: null,
          vara: null,
          juiz: null,
          nome_conjuge_1: null,
          nome_conjuge_2: null,
          data_averbacao: null,
          isento: false,
          gerar_protocolo: false,
          gerar_os: false,
          nome_requerente: null,
          cpf_requerente: null,
          ordem_servico_id: null,
          protocolo_id: null,
          deleteds: [],
          texto_procedimento: null
        },
        showFile: false,
        estados: [],
        cidades: [],
        cartorios: [],
        citiesFiltered: []
      }
    },
    mounted () {
      if (this.propForm) {
        this.form = { ... this.form, ...this.propForm}
      }

      if (this.form.data_sentenca) {
        this.form.data_sentenca = moment(this.form.data_sentenca).format('YYYY-MM-DD')
      }

      if (this.form.data_escritura) {
        this.form.data_escritura = moment(this.form.data_escritura).format('YYYY-MM-DD')
      }

      if (this.form.data_transito_julgado) {
        this.form.data_transito_julgado = moment(this.form.data_transito_julgado).format('YYYY-MM-DD')
      }

      if (this.form.data_mandado) {
        this.form.data_mandado = moment(this.form.data_mandado).format('YYYY-MM-DD')
      }

      if (this.form.data_averbacao) {
        this.form.data_averbacao = moment(this.form.data_averbacao).format('YYYY-MM-DD')
      }

      if (this.form.isento) {
        this.form.isento = true
      }

      if (this.form.cpf_requerente) {
        this.form.cpf_requerente = maskCPF(this.form.cpf_requerente)
      }

      if (!this.form.data_averbacao) {
        this.form.data_averbacao = moment(new Date()).format('YYYY-MM-DD')
      }
    },
    async beforeMount () {
      const estados = await EnderecosService.getStates()

      this.estados = estados.sort((a,b) => { return (a.nome > b.nome) ? 1 : -1 })

      this.cidades = await EnderecosService.getCities()
    },
    methods: {
      async deleteDocumento (index) {
        const documento = this.form.procedimentoArquivo[index]

        if (documento.procedimento_arquivo_id) {
          const res = await displayMessage('question', 'Tem certeza que deseja excluir esse documento?')

          if (res.value) this.form.deleteds.push(documento.procedimento_arquivo_id)
          else return
        }

        this.form.procedimentoArquivo.splice(index, 1)

        if (!this.form.procedimentoArquivo.length) {
          this.showFile = true
        }
      },
      async editarProcedimento () {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        this.$emit('atualizarProcedimento', this.form)
      },
      dragArea ($event) {
        const element = document.querySelector('.DropArea')
        element.classList.add('DropAreaDrag')
        $event.preventDefault()
      },
      dragAreaOut ($event) {
        const element = document.querySelector('.DropArea')
        element.classList.remove('DropAreaDrag')
        $event.preventDefault()
      },
      drop () {
        const element = document.querySelector('.DropArea')
        element.classList.remove('DropAreaDrag')
      },
      addArquivo (event) {
        const { files } = event.target

        for (let file of files) {
          this.form.procedimentoArquivo.push(file)
        }

        // Precisamos resetar o campo para poder enviar os mesmos arquivos novamente
        // Ex.: O usuário excluiu o arquivo da lista e subiu o mesmo arquivo novamente
        event.target.value = ''

        this.showFile = false

        this.changed()
      },
      changed () {
        setTimeout(() => {
          this.$emit('changed', this.form)
        }, 100)
      },
      async ufChanged (uf) {
        if (!uf) {
          this.form.uf = null
          this.changed()
          return
        }
        this.citiesFiltered = []


        const estado = this.estados.find(estado => estado.uf === uf)

        if (estado) {
          this.form.uf = estado.uf
          this.citiesFiltered = this.cidades.filter(cidade => cidade.uf == estado.uf)
        }
      },
      async salvarProcedimento () {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        this.$emit('salvarProcedimento', this.form)
      },
      async searchCPF () {
        let cpf = filterMaskedNumber(this.form.cpf_requerente)

        if (cpf && cpf.length > 10) {
          const dados = await PessoasService.getPessoaByCPF(cpf)

          if (dados.isEmpty) return

          const { nome } = dados

          if (nome) this.form.nome_requerente = nome
        }

        this.changed()
      }
    }
  }
</script>

<style lang="scss">
  .SeparacaoEDivorcio {

  }

  .livroCaixaLancamentoArquivoObrigatorios {
  &--fileDisabled {
    background-color: #e9ecef;
    padding: 6px 15px;
    border-radius: 2px;
    font-size: 0.875rem;
    font-weight: 400;
    color: #495057;
    border: 1px solid #ced4da;
  }
}

.DropArea {
  height: 100px;
  padding: 5px;
  background-color: #f4f4f4;
  border: 2px dashed #086AAE;
}

.DropAreaDrag {
  height: 100px;
  padding: 5px;
  background-color: #3498db;
  color: #fff;
  border-color: #086AAE;
}

.fileObrigatorio {
  height: 95px;
  padding: 5px;
  width: 94%;
  margin-top: 4px;
  background-color: #f4f4f4;
  border-color: #086AAE;
  opacity: 0;
  z-index: 10;
  position: absolute;
  top: 0;
}

.icon-add-images {
    fill: #fff !important;
    width: 18px;
    height: 18px;
  }

</style>
